import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { pawtucketConfig } from "./data";

export default function PawtucketPage() {
  return <CityPageTemplate config={pawtucketConfig} />;
}